import './Header.css';
import React, { Component } from 'react';

export default class Header extends Component {
  render() {
    return (
      
      <>
        <header className='headerFun'>

          {/* --------------------------------------------------------------------- */}

          <h1>Oregon Environmental Data Initiative</h1>

          {/* --------------------------------------------------------------------- */}

        </header>
      </>
    )
  }
}
